import { apiService } from "../../services/apiService";
import { utilService } from "../../services/utilService";
import { apiServiceConstants } from "../../constants";
import {
  CurrentUserModel,
  OtherUserListModel,
  HomePageParams,
} from "./Home.model";
import { doctorsListService } from "../../components/Shared/DoctorList/doctor-list-service";
const getHomePageData = async (params: HomePageParams): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `user/homepage-list-v2/?reg_code=` +
        utilService.getNetwork() +
        `&hour=` +
        params.hour +
        `&minute=` +
        params.minute +
        `&date=` +
        params.date,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const homeResp = res as any;
      const HomeResult = setHomeRespModel(homeResp.result?.[0]);
      const result: any = {
        isSuccess: true,
        status: homeResp.status,
        message: homeResp.message,
        result: HomeResult,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const setHomeRespModel = (payload: any): any => {
  const homeResult = {
    currentUser: setCurrentUser(payload.current_user),
    otherUserList: setOtherUserList(payload.other_user_list),
  };

  return homeResult;
};

const setCurrentUser = (payLoad: any) => {
  const currentUser: CurrentUserModel = {
    available: payLoad.available,
    firstName: payLoad.first_name,
    lastName: payLoad.last_name,
    nextShift: payLoad.next_shift,
    nextShiftHours: payLoad.next_shift_hours,
    profilePic: payLoad.profile_pic,
  };
  return currentUser;
};

const setOtherUserList = (payLoad: any) => {
  const otherUserList: OtherUserListModel = {
    added: setAddedList(payLoad.added),
    own: setOwnList(payLoad.own),
  };
  return otherUserList;
};

const setAddedList = (payLoad: any) => {
  const addedObjects: any = {};
  Object.entries(payLoad).forEach(([key, value]) => {
    let valueItem: any = value;
    addedObjects[key] = {
      data: doctorsListService.setDoctorListModel(valueItem.data),
      scheduleId: valueItem.schedule_id,
    };
  });
  return addedObjects;
};

const setOwnList = (payLoad: any) => {
  const ownObjects: any = {};
  Object.entries(payLoad).forEach(([key, value]) => {
    let valueItem: any = value;
    ownObjects[key] = {
      data: doctorsListService.setDoctorListModel(valueItem.data),
      schedule_id: valueItem.schedule_id,
    };
  });
  return ownObjects;
};

export const homePageService = {
  getHomePageData,
};
